import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { DatabaseClient, databaseApiRef } from './api/DatabaseApi';

export const databasePlugin = createPlugin({
  id: 'database',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: databaseApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DatabaseClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** The database inventory, mounted at /database. */
export const DatabasePage = databasePlugin.provide(
  createRoutableExtension({
    name: 'DatabasePage',
    component: () =>
      import('./components/DatabaseManagerPage').then(m => m.DatabaseManagerPage),
    mountPoint: rootRouteRef,
  }),
);

/**
 * Entity page tabs. These render inside the catalog's Resource page rather than
 * a plugin route, so a database keeps its About card, relations and ownership
 * alongside the management tools.
 */
export const EntityDatabaseOverviewContent = databasePlugin.provide(
  createComponentExtension({
    name: 'EntityDatabaseOverviewContent',
    component: {
      lazy: () => import('./components/tabs/OverviewTab').then(m => m.OverviewTab),
    },
  }),
);

export const EntityDatabaseTerminalContent = databasePlugin.provide(
  createComponentExtension({
    name: 'EntityDatabaseTerminalContent',
    component: {
      lazy: () => import('./components/tabs/TerminalTab').then(m => m.TerminalTab),
    },
  }),
);

export const EntityDatabaseStatsContent = databasePlugin.provide(
  createComponentExtension({
    name: 'EntityDatabaseStatsContent',
    component: {
      lazy: () => import('./components/tabs/StatsTab').then(m => m.StatsTab),
    },
  }),
);

export const EntityDatabaseManageContent = databasePlugin.provide(
  createComponentExtension({
    name: 'EntityDatabaseManageContent',
    component: {
      lazy: () => import('./components/tabs/ManageTab').then(m => m.ManageTab),
    },
  }),
);

export const EntityDatabaseSchemaContent = databasePlugin.provide(
  createComponentExtension({
    name: 'EntityDatabaseSchemaContent',
    component: {
      lazy: () => import('./components/tabs/SchemaTab').then(m => m.SchemaTab),
    },
  }),
);
